module.exports = __webpack_public_path__ + "assets/virtualClassroom-mobile.69e2786625719192a826ae2bc3011b1e.png";